import Axios from 'axios';
import axios from './axios';
import { generateUUID } from '@Sage/ssm-utils';

export const getLiterals = (page, search, count) =>
    axios.get('/literals/v1', { params: { page, search }, headers: { count } });

export const updateLiterals = (data) =>
    axios.put(
        '/literals/v1',
        data,
        { count: data.length },
        {
            timeout: 60 * 1000 * 10, // 10 min
        },
    );

export const getLiteralsLogin = (lang) =>
    Axios.get('https://fmliterals.forcemanager.net/login/v1/101/' + lang + '.json');

// Generic Literals API
export const getGenericLiterals = (page, search, count) =>
    axios.get('/literals/v1/genericCFM', { params: { page, search }, headers: { count } });

export const createGenericLiteral = (data) => axios.post('/literals/v1/genericCFM', data);

export const updateGenericLiteral = (data) => axios.put('/literals/v1/genericCFM', data);

export const translateLiteral = (text) =>
    axios
        .post('/analyzer/v1/copilot', [
            {
                event_id: generateUUID(),
                type: 'session.create',
                session: {
                    modalities: ['text'],
                    features: ['multi_language_translation'],
                },
            },
            {
                event_id: generateUUID(),
                type: 'conversation.item.create',
                item: {
                    content: {
                        query: text,
                    },
                    id: generateUUID(),
                    role: 'user',
                    type: 'params',
                },
            },
            {
                event_id: generateUUID(),
                type: 'response.create',
            },
        ])
        .then((response) => {
            const data = response.data.artifacts[0].data;

            if (!data) return {};

            return Object.keys(data).reduce((acc, key) => {
                // API keys are 4-char camelCase (daDk, enGb) -> convert to locale "da-dk", "en-gb"
                const formatKey = () =>
                    (key.length === 4
                        ? `${key.slice(0, 2)}-${key.slice(2, 4)}`
                        : key
                    ).toLowerCase();

                const formKey = `languageValues.${formatKey()}`;
                acc[formKey] = data[key];
                return acc;
            }, {});
        });
